<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import IconSprite from "@/components/IconSprite.vue";
import formValidierung from "@/businesslogic/formValidierung";
import { inputChangeHandler } from "@/businesslogic/utils/events";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "SanierungsfragenElement",
  methods: { inputChangeHandler },
  components: { ValidierungsFehler, IconSprite },
  props: {
    name: String,
    infoText: String,
    jahrChecked: Boolean,
    jahr: Number,
    fehler: Object,
    sanierungsfrage: Object,
    schmalesLabel: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const piniaStore = useFormStore();

    const showables = ref({
      showHelp: false,
    });

    const { erzwingeGanzzahl } = formValidierung();

    const jahrMin = 1800;
    const jahrMax = new Date().getFullYear();
    const jahrFehlerText = "Bitte geben Sie das vierstellige Sanierungsjahr (" + jahrMin + " - " + jahrMax + ") ein.";

    const checkboxBreite = computed(() => (props.schmalesLabel ? 3 : 5));
    const infoBreite = computed(() => (props.schmalesLabel ? 4 : 2));

    return {
      showables,
      piniaStore,
      erzwingeGanzzahl,
      jahrMin,
      jahrMax,
      jahrFehlerText,
      checkboxBreite,
      infoBreite,
    };
  },
});
</script>

<template>
  <div class="o-grid">
    <div :class="'o-grid__cell o-grid__cell--' + checkboxBreite + ' u-form-grid-nospace-y label-alignment'">
      <input
        :id="sanierungsfrage?.nameCheckbox"
        :name="sanierungsfrage?.nameCheckbox"
        class="c-form-control-checkbox__input"
        type="checkbox"
        :checked="jahrChecked"
        :required="piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt"
        :aria-required="piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt"
        aria-label="Art der Sanierung"
        data-fehlermeldung="Bei durchgeführter Kernsanierung muss dieses Feld ausgewählt werden"
        data-cy="sanierungsFrage"
        @input="$emit('update:jahrChecked', $event.target.checked)"
      />
      <label class="c-form-control-checkbox__label" :for="sanierungsfrage.nameCheckbox">
        <icon-sprite icon-name="icon-check-mark" css-klassen="c-form-control-checkbox__icon" :ist-klein="true" />
        <span class="c-form-control-checkbox__label-text">
          {{ name }}
        </span>
      </label>
      <validierungs-fehler :fehler-text="fehler[sanierungsfrage.nameCheckbox]" />
    </div>
    <div :class="'o-grid__cell o-grid__cell--' + infoBreite + ' u-form-grid-nospace-y label-alignment'">
      <span class="c-notice-icon" @click="showables.showHelp = !showables.showHelp">
        <icon-sprite icon-name="icon-info-i" />
      </span>
    </div>
    <div class="o-grid__cell o-grid__cell--5 u-form-grid-nospace-y">
      <input
        type="number"
        @keydown="erzwingeGanzzahl"
        :name="sanierungsfrage.nameInput"
        :value="jahr"
        class="c-form-control__input u-mar-t-0"
        data-cy="sanierungsJahr"
        placeholder="JJJJ"
        :min="jahrMin"
        :max="jahrMax"
        :disabled="!jahrChecked"
        :required="jahrChecked"
        :aria-required="jahrChecked"
        aria-label="Jahr der Sanierung"
        :data-fehlermeldung="jahrFehlerText"
        @input="$emit('update:jahr', inputChangeHandler($event))"
      />
      <validierungs-fehler :fehler-text="fehler[sanierungsfrage.nameInput]" />
    </div>
    <div class="o-grid__cell o-grid__cell--12 u-grid-no-y-gutter u-pad-b-1">
      <div v-if="showables.showHelp" class="gev19__contexthelp-text o-grid__cell--no-space">
        <p>
          {{ infoText }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label-alignment {
  padding-top: 0.575rem !important;
}
</style>
